import React from 'react';

interface CollapsedNavBadgeProps {
  count: number;
}

const formatBadgeCount = (count: number): string => (count > 99 ? '99+' : String(count));

const CollapsedNavBadge: React.FC<CollapsedNavBadgeProps> = ({ count }) => (
  <span
    aria-hidden="true"
    className="bg-sidebar-brand text-sidebar-brand-foreground absolute -top-1 -right-2 min-w-[1rem] rounded-full px-1 text-[10px] leading-4 font-semibold text-center"
  >
    {formatBadgeCount(count)}
  </span>
);

export default CollapsedNavBadge;
